import trackEvent from '../../helpers/gtm/eventPush';
import trackingStepBack from './tracking_back_link_mobile.js';

import '../../../sass/pages/post_ads/free_bold_options_mobile_bullets.scss';
import '../../components/earlyBird_modal.jsx';
import exampleAdvertModal from '../account/ad_example_modal';
import explanationboldModal from './bold_modal';
import examplePriceModal from './price_modal';

trackingStepBack();
exampleAdvertModal();
explanationboldModal();
examplePriceModal();

const postFreeAdBtn = document.getElementById('postFreeAd');
const postBoldAdBtn = document.getElementById('postBoldAd');
const seeExampleAd = document.getElementById('adExamples');
const seePrices = document.getElementById('seePrices');

function trackButton(option) {
  return trackEvent({
    category: 'ads',
    action: `options_select_${option}`,
    label: window._sr.site.loginReturnPath,
  });
}

if (postFreeAdBtn) {
  postFreeAdBtn.addEventListener('click', () => {
    trackButton('free');
  });
}

if (postBoldAdBtn) {
  postBoldAdBtn.addEventListener('click', () => {
    trackButton('bold');
  });
}

if (seeExampleAd) {
  seeExampleAd.addEventListener('click', () => {
    trackEvent({
      category: 'ads',
      action: 'free_bold_options_see_bold_example',
    });
  });
}

if (seePrices) {
  seePrices.addEventListener('click', () => {
    trackEvent({
      category: 'ads',
      action: 'free_bold_options_see_prices',
    });
  });
}
